import React from "react";
import autoBind from 'react-autobind';

class TemplateViewer extends React.Component{
	constructor(props){
		super(props);
		this.state = {
			chosenTable: this.props.values.chosenTable.tableName,
			name: this.props.values.name,
			intent: this.props.values.intent,
			format: this.props.values.format,
			commit: this.props.values.commit,
			script: this.props.values.script,
			token: this.props.values.token,
			columns: this.props.values.columns
		};
		autoBind(this);
	}

	componentWillReceiveProps(nextProps){
		this.setState(
			{
				chosenTable: nextProps.values.chosenTable,
				name: nextProps.values.name,
				intent: nextProps.values.intent,
				format: nextProps.values.format,
				commit: nextProps.values.commit,
				script: nextProps.values.script,
				token: nextProps.values.token,
				columns: nextProps.values.columns
			}, function () {
				this.forceUpdate();
			}.bind(this)
		);
	}

	generateTemplateSection(){
		let template = "[Template]\nTemplateVersion = 1.0\nTableID = " +
			this.props.values.chosenTable.tableName + "\nTemplateName = " +
			this.props.values.name + "\nIntent = " +
			this.props.values.intent + "\nFormat = " +
			this.props.values.format +
			(this.props.values.intent === 'Retrieve' ? "": "\nCommit = " + this.props.values.commit) +
			"\nStructuredData = " + (this.props.values.format === "CSV" ? "False": "True") +
			(this.props.values.format === 'JSON' && this.props.values.intent === 'Retrieve' ? "\nOutputHeader=false" : "") +
			"\n";
		return template;
	}

	generateOutputSection(){
		let columns = this.props.values.columns;
		let output = "[Output]\n";
		for (let key in columns) {
			if (columns[key].Checked){
				if (columns[key].displayMeasurement && columns[key].selectedUnit !== ""){
					let line = columns[key].Name + "(" + columns[key].selectedUnit + ") = Input." + columns[key].Name + "\n";
					output = output + line;
				}
				else if (columns[key].displayTimeData){
					if (columns[key].timeData.selectedTimeZone === "" && columns[key].timeData.selectedTimeFormat !== ""){
						let line = columns[key].Name + "(" + columns[key].timeData.selectedTimeFormat + ") = Input." + columns[key].Name + "\n";
						output = output + line;
					}
					else if (columns[key].timeData.selectedTimeZone !== "" && columns[key].timeData.selectedTimeFormat !== ""){
						let line = columns[key].Name + "(" + columns[key].timeData.selectedTimeFormat + ", " + columns[key].timeData.selectedTimeZone + ") = Input." + columns[key].Name + "\n";
						output = output + line;
					}

				}
				else {
					let line = columns[key].Name + " = Input." + columns[key].Name + "\n";
					output = output + line;
				}
			}
		}
		return output;
	}

	generateScriptSection(){
		if (this.props.values.script !== "True"){
			return "";
		}
		else if(this.props.values.scriptSelections["All"] === true){
			return "[Script]\n" +
				"(function(tde){\n" +
				"\ttde.onRow = function(row) {\n" +
				"\t\treturn [row];\n" +
				"\t}\n" +
				"\ttde.onRowsFinished = function() {\n" +
				"\t\treturn [];\n" +
				"\t}\n" +
				"\ttde.onCommit = function(row) {\n" +
				"\t\treturn [row];\n" +
				"\t}\n" +
				"})(tde)"
		}
		else{
			let output = "[Script]\n(function(tde){\n";
			if(this.props.values.scriptSelections["onRow"] === true){
				output += "\ttde.onRow = function(row) {\n" +
					"\t\treturn [row];\n" +
					"\t}\n"
			}
			if(this.props.values.scriptSelections["onRowsFinished"] === true){
				output += "\ttde.onRowsFinished = function() {\n" +
					"\t\treturn [];\n" +
					"\t}\n"
			}
			if(this.props.values.scriptSelections["onCommit"] === true){
				output += "\ttde.onCommit = function(row) {\n" +
					"\t\treturn [row];\n" +
					"\t}\n"
			}
			output += "})(tde)";
			return output;
		}


	}

	render(){
		let view = "";
		let template = this.generateTemplateSection();
		let output = this.generateOutputSection();
		let script = this.generateScriptSection();
		view = view + template + "\n" + output + "\n" + script;
		return(
			<div className="template-viewer" id="template-viewer">
                <textarea id="template-textarea" readOnly={true} value={view} style={{resize:'none'}}>
                </textarea>
			</div>
		);

	}
}

export default TemplateViewer;